export default "__VITE_ASSET__CvO1MMCN__"